/**
 * TanStack Query hooks for `itet-install-to-event-time-rule`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	itetInstallToEventTimeRuleQueryKeys,
	type CreateItetInstallToEventTimeRuleBody,
	type ListItetInstallToEventTimeRuleResponse,
	type ItetInstallToEventTimeRuleRow,
} from "./api";

export function useItetInstallToEventTimeRuleList(): UseQueryResult<ListItetInstallToEventTimeRuleResponse, Error> {
	return useQuery({
		queryKey: itetInstallToEventTimeRuleQueryKeys.list(),
		queryFn: list,
	});
}

export function useItetInstallToEventTimeRuleCreate(): UseMutationResult<ItetInstallToEventTimeRuleRow, Error, CreateItetInstallToEventTimeRuleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: itetInstallToEventTimeRuleQueryKeys.all });
		},
	});
}

export function useItetInstallToEventTimeRuleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: itetInstallToEventTimeRuleQueryKeys.all });
		},
	});
}
